/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUndo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16.992 9.5H9.996V6L5 10.5 9.996 15 10 11.5h6.992s-.012 1.959 0 2c0 2.167.008 3.333.008 5.5h2v-7c.006-.278 0-.286 0-.5 0-2-2.008-2-2.008-2" /></svg>;
export default SvgUndo;